export const fr = {
    instructionHeader: 'Combien coûtent mes lunettes de vue ?',
    instructionHeaderMultifocalTemplate:
        'Combien coûtent mes lunettes de vue multifocales?',
    instructionBody: `En outre, nous avons composé des forfaits verres des plus clairs :
        Silver, Gold, Diamond et Platinum. De cette façon, vous
        trouvez tout de suite les verres unifocaux que vous souhaitez et vous
        en connaissez immédiatement le prix. Une clarté absolue, donc.`,
    single: 'Unifocaux',
    multifocal: 'Progressifs',
    storeOnly: 'Seulement dans les magasins',
    overview: 'Aperçu',
    discount: 'Monture gratuite',
    included: 'inclus',
    glassesPackage: 'pack de verres',
    frame: 'Monture',
    glassesPrice: 'Prix des lunettes',
    youPay: 'Prix total',
    topChoice: 'Les plus choisis',
    errorFetching: 'Une erreur est survenue',
    tooltipText: 'Non disponible',
    extraOption: `Vous souhaitez ajouter une option supplémentaire ?`,
    footer: `Veuillez noter que vous pouvez commander des verres en ligne avec différents emballages et options de verre, mais que toutes les options de verre supplémentaires ne sont pas possibles lors de la commande en ligne. Vous avez des questions ? <1>N'hésitez pas à nous contacter</1>.`,
};
